import React from 'react'

type Props = {}

const PDFIcon = (props: Props) => {
  return (
    <svg
      width='50'
      height='66'
      viewBox='0 0 50 66'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M0 8C0 3.58172 3.58172 0 8 0H33.547L39.9573 5.98291L50 14.7436V57.812C50 62.2302 46.4183 65.812 42 65.812H8C3.58172 65.812 0 62.2302 0 57.812V8Z'
        fill='#E2574C'
      />
      <path
        d='M33.3923 10.5228L33.547 0L50 14.7436L37.3406 14.5813C35.1287 14.5529 33.3597 12.7346 33.3923 10.5228Z'
        fill='#B53629'
      />
      <path
        d='M37.0858 30.0554C37.684 30.0554 37.9769 29.534 37.9769 29.0286C37.9769 28.5053 37.6715 28 37.0858 28H33.6786C33.0125 28 32.6411 28.5517 32.6411 29.1607V37.5339C32.6411 38.2804 33.0661 38.6946 33.6411 38.6946C34.2126 38.6946 34.6394 38.2804 34.6394 37.5339V35.2357H36.7001C37.3394 35.2357 37.6591 34.7125 37.6591 34.1929C37.6591 33.6841 37.3394 33.1785 36.7001 33.1785H34.6394V30.0554H37.0858ZM25.5697 28H23.0768C22.3999 28 21.9195 28.4643 21.9195 29.1535V37.5411C21.9195 38.3964 22.6106 38.6643 23.1052 38.6643H25.7214C28.8177 38.6643 30.8624 36.6269 30.8624 33.4821C30.8607 30.1572 28.9358 28 25.5697 28ZM25.6894 36.5966H24.1697V30.0679H25.5394C27.6126 30.0679 28.5143 31.4591 28.5143 33.3786C28.5143 35.1751 27.6285 36.5966 25.6894 36.5966ZM16.5572 28H14.0875C13.3893 28 13 28.4606 13 29.1607V37.5339C13 38.2804 13.4464 38.6946 14.0463 38.6946C14.6463 38.6946 15.0927 38.2804 15.0927 37.5339V35.0892H16.6409C18.5516 35.0892 20.1284 33.7356 20.1284 31.5588C20.1286 29.4286 18.6072 28 16.5572 28ZM16.5162 33.1251H15.0929V29.9661H16.5162C17.3947 29.9661 17.9537 30.6518 17.9537 31.5465C17.9518 32.4394 17.3947 33.1251 16.5162 33.1251Z'
        fill='white'
      />
    </svg>
  )
}

export default PDFIcon
